/**
 * Componente: Modal de configuración de impresión (flujo de 2 pasos)
 * Selector puro: no guarda nada por su cuenta, solo junta tipo_impresion +
 * tipo_tarjeta y se los devuelve al que lo abrió vía onSeleccionar. Lo usa
 * tanto el flujo de "+ Nuevo diseño" (antes de pedir nombre/logo/colores)
 * como el botón "Cambiar configuración de impresión" al editar un diseño.
 */

import React, { useState } from 'react';
import { IdCard, Layers, CreditCard, Stamp, ArrowLeft } from 'lucide-react';
import { IconCerrar } from './icons';

// Cuánto se ve resaltada la tarjeta elegida antes de avanzar/confirmar, para
// que la selección se perciba antes de que cambie la pantalla.
const DELAY_TRANSICION_MS = 350;

const ConfiguracionImpresionModal = ({ valorInicial, obligatorio, onClose, onSeleccionar }) => {
  const [paso, setPaso] = useState(1);
  const [tipoImpresion, setTipoImpresion] = useState(valorInicial?.tipo_impresion || '');
  const [tipoTarjeta, setTipoTarjeta] = useState(valorInicial?.tipo_tarjeta || '');

  const elegirTipoImpresion = (valor) => {
    setTipoImpresion(valor);
    setTimeout(() => setPaso(2), DELAY_TRANSICION_MS);
  };

  const elegirTipoTarjeta = (valor) => {
    setTipoTarjeta(valor);
    setTimeout(() => onSeleccionar(tipoImpresion, valor), DELAY_TRANSICION_MS);
  };

  const volver = () => setPaso(1);

  return (
    <div className="modal-overlay">
      <div className="modal-content configuracion-impresion-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="disenador-form-header-titulo">
            {!obligatorio && (
              <button type="button" className="btn-volver" onClick={onClose}>
                <ArrowLeft size={16} /> Volver
              </button>
            )}
            <h2>{paso === 1 ? '¿Cómo van a imprimir las licencias?' : '¿Qué tipo de tarjeta van a usar?'}</h2>
          </div>
          {!obligatorio && <button className="modal-close" onClick={onClose}><IconCerrar size={18} /></button>}
        </div>

        <div className="modal-body">
          <div className="pasos-progreso">
            <div className="pasos-progreso-barra">
              <div className={`pasos-progreso-segmento ${paso >= 1 ? 'activo' : ''}`}></div>
              <div className={`pasos-progreso-segmento ${paso >= 2 ? 'activo' : ''}`}></div>
            </div>
            <span className="pasos-progreso-label">Paso {paso} de 2</span>
          </div>

          {paso === 1 ? (
            <div className="opciones-grid">
              <button
                type="button"
                className={`opcion-card ${tipoImpresion === 'una_cara' ? 'seleccionada' : ''}`}
                onClick={() => elegirTipoImpresion('una_cara')}
              >
                <IdCard className="opcion-icono" size={40} strokeWidth={1.5} />
                <span className="opcion-texto">Una cara</span>
              </button>
              <button
                type="button"
                className={`opcion-card ${tipoImpresion === 'doble_cara' ? 'seleccionada' : ''}`}
                onClick={() => elegirTipoImpresion('doble_cara')}
              >
                <Layers className="opcion-icono" size={40} strokeWidth={1.5} />
                <span className="opcion-texto">Doble cara</span>
              </button>
            </div>
          ) : (
            <>
              <div className="opciones-grid">
                <button
                  type="button"
                  className={`opcion-card ${tipoTarjeta === 'blanca' ? 'seleccionada' : ''}`}
                  onClick={() => elegirTipoTarjeta('blanca')}
                >
                  <CreditCard className="opcion-icono" size={40} strokeWidth={1.5} />
                  <span className="opcion-texto">Blanca</span>
                </button>
                <button
                  type="button"
                  className={`opcion-card ${tipoTarjeta === 'preimpresa' ? 'seleccionada' : ''}`}
                  onClick={() => elegirTipoTarjeta('preimpresa')}
                >
                  <Stamp className="opcion-icono" size={40} strokeWidth={1.5} />
                  <span className="opcion-texto">Preimpresa</span>
                </button>
              </div>

              <button type="button" className="btn-atras" onClick={volver}>
                <ArrowLeft size={16} /> Atrás
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfiguracionImpresionModal;
